module.exports = __webpack_public_path__ + "static/img/bids_submitted_image.ac00aa21.png";